var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('group-list',{ref:"groupList",staticClass:"mb-3"}),_c('v-overlay',{attrs:{"value":_vm.saving}},[_c('div',{staticClass:"cdn-progress-logo",staticStyle:{"width":"64px","height":"64px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }